import { ConnectProto } from "@racoon/api";
import { Namespace, TFn, TranslationKey } from "@racoon/i18n";

export const jobTypeLabel = (type: ConnectProto.JobType, t: TFn): string => {
  const name = ConnectProto.JobTypeSchema.values.find((value) => value.number === type)?.name;
  return name ? t(Namespace.Enum, name as TranslationKey) : "-";
};
